import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { SharedService } from '../services/sharedService';
import { CommonConstants } from './../utilities/commonConstants';
import { ConfigService } from '../services/config.service';
import { CookieHandlerService } from './cookieHandler.service';
import { HttpInterceptor } from './../services/httpInterceptor.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RouteContextProvider } from './../services/routeContextProvider.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ActivitiHandlerService {
    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _cookieHandler: CookieHandlerService,
        private _router: Router,
        private _sharedService: SharedService) {

    }
    public StartActiviti(data: any, isLoader?: boolean): Observable<ActivitiModel.MTResponse<any>> {
        return this._httpInterceptor.Post(
            ConfigService.getInstance().getConfigObject()
                .APIURL.startApplicationActiviti, data, isLoader);
    }

    public MarkTaskAsCompleted(
        requestData: any,
        taskName?: string,
        isLoader?: boolean,
        loadermsg?: string
    ): Observable<ActivitiModel.MTResponse<any>> {
        // this is typicaly for custom loader text.
        // ConfigService.getInstance().setTitle(loadermsg);
        return this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.completeActivitiTask,
            this.getCompleteTaskRequest(requestData, taskName), isLoader);
    }

    public GetTaskDetails(
        taskName?: string,
        isLoader?: boolean,
        loadermsg?: string
    ): Observable<ActivitiModel.MTResponse<any>> {
        // this is typicaly for custom loader text.
        // ConfigService.getInstance().setTitle(loadermsg);
        return this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.getActivitiTaskDetails,
            this.getTaskDetailsRequest(taskName), isLoader);
    }
    public GetEsignDetails(data,isLoader
    ): Observable<ActivitiModel.MTResponse<any>> {
        // this is typicaly for custom loader text.
        // ConfigService.getInstance().setTitle(loadermsg);
        return this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.validateEsign,
            data, isLoader);
    }
    public SendOtp(data,isLoader
    ): Observable<ActivitiModel.MTResponse<any>> {
        return this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.generateOtp,
            data, isLoader);
    }
    
    public validateOtp(data: any) {
        return this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.validateEsignOTP.replace('{0}', data.applicationId), data, false); 
    }

    //fn added since we are no getting ProcessInstanceDetails cookies in the process call of resume app
    private checkProcessInstanceDetailsCookies() {
        let sharedServiceLoanApplicationId = this._sharedService.getData('LoanApplicationId');
        let processInstanceCookieWithLoanAppId = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.ProcessInstanceDetails);
        let processInstanceCookieOriginal = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.ProcessInstanceDetails);

        if (processInstanceCookieWithLoanAppId && processInstanceCookieWithLoanAppId !== '')
            return processInstanceCookieWithLoanAppId;
        else if (processInstanceCookieOriginal && processInstanceCookieOriginal !== '')
            return processInstanceCookieOriginal;
        else
            return "";  //logically this case should never come
    }

    private getCompleteTaskRequest(requestData: any, taskName: string): ActivitiModel.ActivitiRequest {
        return <ActivitiModel.ActivitiRequest>{
            activitiName: 'complete',
            action: taskName,
            processId: this.checkProcessInstanceDetailsCookies(),
            payload: requestData
        };
    }

    private getTaskDetailsRequest(taskName?: string): ActivitiModel.ActivitiRequest {
        const currentRoute = this._router.url.split(CommonConstants.URL_SEPARATOR);
        return <ActivitiModel.ActivitiRequest>{
            processId: this.checkProcessInstanceDetailsCookies(),
            action: taskName,
            routesInfo: {
                mainRoute: currentRoute[1],
                subRoute: currentRoute[2] || CommonConstants.DEFAULT_EMPTY_STRING
            }
        };
    }
}
